import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// Services
import {
    confirmDepositPromotion
} from "../../../../../../../@core/services/depositService";
import { setStatusSpinner } from "../../../../../../../@core/redux/actions/app/spinner";

// Redux
import { openPromotionPopup } from "./../../../../../../../@core/redux/actions/promotion/index";

// Icon
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

// @Utility
import copyText from "./../../../../../../../@utility/app/copyText";
import currencyFormat from "./../../../../../../../@utility/numbers/currencyFormat";
import alertText from "../../../../../../../@utility/app/alertText";

// CSS
import styles from "./../../../../assets/css/Style.module.css";
import buttonStyles from "./../../../../assets/css/Button.module.css";

// Component
import Switch from "./../../component/Switch";
import BoxSlip from './BoxSlip';

// Icon
import ContentCopyIcon from '@material-ui/icons/FileCopy';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

export default function BoxResult({ reloadData, depositItems, reduxPromotionPopup, openBox, promotionItem, timeDepositProcess, timeShow }) {
    const dispatch = useDispatch();
    const [promotionSwitch, setPromotionSwitch] = useState(false);
    const homeData = useSelector(state => state.reduxHome.result);
    let snackbarJson = {};
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));

    const openPromotion = (data) => {
        dispatch(openPromotionPopup({
            tab: "promotionPopup",
            show: true,
            promotionId: data.id,
            promotionData: data
        }));
    };

    // const explodeDecimal = (decimal) => {
    //     let decimalSplit = decimal.split(".");

    //     return <>
    //         {decimalSplit[0]}.<span style={{ color: "#FFE600" }}>{decimalSplit[1]}</span>
    //     </>
    // };

    const copyData = (data) => {
        if (copyText(data)) {
            snackbarJson = {
                statusShow: true,
                statusAlert: "success",
                titleAlert: "แจ้งเตือน",
                textAlert: "คัดลอกสำเร็จ !"
            };

            openBox(snackbarJson);
        }
    };

    const renderCoyNumberAmountContent = () => (
        <div className="boxDetailQRCodeScanNumberTransfer">
            <Grid container alignItems="center" justify="space-between" spacing={1}>
                <Grid item>ยอดโอน :</Grid>
                <Grid item>
                    <div className="boxDetailQRCodeScanNumberTransferTitle textBold center">
                        {(() => {
                            const formatted = currencyFormat(Number(depositItems?.amount || 0), 2);
                            const [intPart, decPart] = formatted.split('.');
                            return (
                                <>
                                    <span>{intPart}</span>
                                    {decPart !== undefined && <span style={{ color: 'var(--bt-danger)' }}>.{decPart}</span>} {' '}
                                    บาท
                                </>
                            );
                        })()}
                    </div>
                </Grid>
                <Grid item>
                    <button
                        type="button"
                        className={`boxDetailQRCodeScanNumberTransferCopy ${!timeDepositProcess ? '' : 'btnHover'}`}
                        style={{ opacity: !timeDepositProcess ? '0.5' : 1 }}
                        disabled={!timeDepositProcess}
                        onClick={() => timeDepositProcess && copyData(currencyFormat(Number(depositItems?.amount || 0), 2))}
                    >
                        <Grid container alignItems="center" justify="center" spacing={1}>
                            <Grid item><ContentCopyIcon className="iconTransactionaction iconTransactionactionRe" /></Grid>
                            <Grid item>คัดลอก</Grid>
                        </Grid>
                    </button>
                </Grid>
            </Grid>
        </div>
    );

    useEffect(() => {
        if (promotionSwitch === false) {
            dispatch(openPromotionPopup({
                tab: "promotionPopup",
                show: false,
                promotionId: 0,
                promotionSelect: false,
                promotionData: null
            }));
        }
        // else {
        //     if (promotionItem.length === 1) {
        //         dispatch(openPromotionPopup({
        //             tab: "promotionPopup",
        //             show: false,
        //             promotionSelect: true,
        //             promotionId: promotionItem[0].id,
        //             promotionData: promotionItem[0]
        //         }));
        //     }
        // }
    }, [promotionSwitch]);

    useEffect(() => {
        if (reduxPromotionPopup?.promotionData && depositItems?.mode === 'pay') {
            if (reduxPromotionPopup?.promotionData?.id && reduxPromotionPopup?.promotionSelect) {
                dispatch(setStatusSpinner({ status: true, textProcess: "ระบบกำลังทำรายการ กรุณารอสักครู่" }));
                const dataJson = {
                    td_id: depositItems?.id,
                    promotion_status: true,
                    promotion_condition_id: reduxPromotionPopup?.promotionData?.id
                };

                confirmDepositPromotion(dataJson).then((data) => {
                    const statusCode = data.code;
                    dispatch(setStatusSpinner({ status: false, textProcess: null }));
                    if (statusCode === 200 || statusCode === 0) {
                        openBox({
                            statusShow: true,
                            statusAlert: "success",
                            titleAlert: "แจ้งเตือน",
                            textAlert: "เลือกโปรโมชั่นสำเร็จ !"
                        });

                        reloadData("none");
                    }
                    else {
                        dispatch(openPromotionPopup({
                            tab: "promotionPopup",
                            show: false,
                            promotionId: 0,
                            promotionSelect: false,
                            promotionData: null
                        }));

                        openBox(alertText(statusCode));
                    }
                });
            }
        }
    }, [reduxPromotionPopup]);

    return (
        <>
            <div className="contentBoxMarginTop center" style={{ marginTop: !isLargeScreen ? "-10px" : 0 }}>
                <ArrowDownwardIcon className="transactionIconArrowDown" />
            </div>

            <div className={styles.boxDetailTop}>
                <div className={styles.boxAccountAgentTitle}>
                    โอนเงินมาที่บัญชี
                </div>
                <div className={[styles.boxDetailAmount, styles.boxDetailAgent].join(" ")} style={{ marginTop: "0px" }}>
                    <Grid container alignItems="center" spacing={3}>
                        <Grid item xs={2}>
                            <img src={depositItems?.agent_bankimg} style={{ width: "100%", borderRadius: "12px" }} alt=" เว็บออนไลน์ที่ให้บริการครบวงจร พร้อมโปรโมชั่นสุดพิเศษรองรับทุกการเสี่ยงโชค สมัครวันนี้รับโบนัสต้อนรับสูงสุด พร้อมระบบฝาก-ถอน อัตโนมัติที่รวดเร็วและปลอดภัยตลอด 24 ชม." />
                        </Grid>
                        <Grid item xs={10}>
                            <div className={styles.boxAccountAgentText} style={{ fontWeight: "600" }}>
                                {depositItems?.agent_bankname}
                                <br />
                                ชื่อบัญชี  : {depositItems?.agent_bank_account_name}
                                <br />
                                เลขบัญชี : {depositItems?.agent_bank_account}
                            </div>
                        </Grid>
                    </Grid>
                    <br />
                    <div className="center" style={{ opacity: timeDepositProcess ? "1" : "0.5" }}>
                        <button className={[buttonStyles.btnConfirm, buttonStyles.btnCopy].join(" ")} onClick={() => timeDepositProcess && copyData(depositItems?.agent_bank_account)}>
                            คัดลอกเลขบัญชี
                        </button>
                    </div>
                    {/* <div className={[styles.boxMarginTop, "center"].join(" ")}>
                        <div className={styles.bankPromotionComment}>
                            ** เมื่อโอนเงินเเล้วกรุณากดยืนยันการโอนเงิน **
                        </div>
                    </div> */}
                </div>
            </div>
            <div className={`${styles.boxDetailTop} ${styles.boxMarginTop}`}>
                <div className="boxDetailAmountQrcodeNumber center" style={{ marginTop: '0px' }}>
                    กรุณาโอนภายใน :{' '}
                    <span className="boxDetailAmountQrcodeNumberText">
                        {timeShow === 'expired' ? 'หมดเวลา' : (timeShow || '00:00')}
                    </span>
                </div>

                <div className="contentMarginTop02">
                    {renderCoyNumberAmountContent()}
                </div>

                <div className="center contentMarginTop02">
                    <div className="bankPromotionComment" style={{ color: 'var(--bg-black)' }}>
                        กรุณาโอนจากบัญชีที่ผูกไว้เท่านั้น ไม่เช่นนั้นจะไม่สามารถทำรายการได้
                    </div>
                </div>
            </div>

            {depositItems?.mode === 'pay' && (
                <div className={styles.boxMarginTop}>
                    <BoxSlip depositItems={depositItems} />
                </div>
            )}

            {
                !depositItems?.promotion_name && (
                    <div className={styles.boxMarginTop}>
                        <div className={styles.boxDetailTop}>
                            <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
                                <Grid item>
                                    <div className={styles.boxAccountAgentTitle}>
                                        {
                                            promotionSwitch ?
                                                "รับโปรโมชั่น"
                                                :
                                                "ไม่รับโปรโมชั่น"
                                        }
                                    </div>
                                </Grid>
                                <Grid item>
                                    <Switch
                                        isOn={promotionSwitch}
                                        onColor="#38C172"
                                        handleToggle={() => setPromotionSwitch(!promotionSwitch)}
                                    />
                                </Grid>
                            </Grid>
                            {
                                promotionSwitch && (
                                    homeData.balance <= process.env.REACT_APP_BALANCE_LIMIT ?
                                        <>
                                            <div className={styles.boxMarginTop}>
                                                <div className={styles.boxAccountAgentSub}>
                                                    โปรโมชั่นเเนะนำสำหรับคุณ (กรุณากดเลือกรับโปรโมชั่น)
                                                </div>
                                            </div>
                                            <div className={styles.boxMarginTop}>
                                                {
                                                    promotionItem !== null && (
                                                        promotionItem.length > 0 ?
                                                            <div className={[styles.menuPositionWidthScroll].join(" ")} style={{ marginLeft: "0px", marginRight: "0px", paddingBottom: "10px" }}>
                                                                <div className="flexContent">
                                                                    {
                                                                        promotionItem.map((item) => {
                                                                            return (
                                                                                (reduxPromotionPopup.promotionSelect && reduxPromotionPopup.promotionId === item.id) ?
                                                                                    <div key={item.id} className="relative" onClick={() => { openPromotion(item) }}>
                                                                                        <img className={reduxPromotionPopup.promotionId === item.id ? styles.imgPromotionListBorder : styles.imgPromotionList} src={item.content_picture} alt=" เว็บออนไลน์ที่ให้บริการครบวงจร พร้อมโปรโมชั่นสุดพิเศษรองรับทุกการเสี่ยงโชค สมัครวันนี้รับโบนัสต้อนรับสูงสุด พร้อมระบบฝาก-ถอน อัตโนมัติที่รวดเร็วและปลอดภัยตลอด 24 ชม." />
                                                                                        {/* <div className={buttonStyles.btnActionPosition}>
                                                                                            <div className={[buttonStyles.btnAction, buttonStyles.btnCancelPromotion].join(" ")}>
                                                                                                ยกเลิกรับโปรโมชั่น
                                                                                            </div>
                                                                                        </div> */}
                                                                                    </div>
                                                                                    :
                                                                                    <div key={item.id} className="relative" onClick={() => { openPromotion(item) }}>
                                                                                        <img className={styles.imgPromotionList} src={item.content_picture} alt=" เว็บออนไลน์ที่ให้บริการครบวงจร พร้อมโปรโมชั่นสุดพิเศษรองรับทุกการเสี่ยงโชค สมัครวันนี้รับโบนัสต้อนรับสูงสุด พร้อมระบบฝาก-ถอน อัตโนมัติที่รวดเร็วและปลอดภัยตลอด 24 ชม." />
                                                                                        {/* <div className={buttonStyles.btnActionPosition}>
                                                                                            <div className={[buttonStyles.btnAction, buttonStyles.btnSelectPromotion].join(" ")}>
                                                                                                เลือกรับโปรโมชั่น
                                                                                            </div>
                                                                                        </div> */}
                                                                                    </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className="center">
                                                                <img className={styles.imgPromotionNone} src="/images/game/promotion_none.webp" alt=" เว็บออนไลน์ที่ให้บริการครบวงจร พร้อมโปรโมชั่นสุดพิเศษรองรับทุกการเสี่ยงโชค สมัครวันนี้รับโบนัสต้อนรับสูงสุด พร้อมระบบฝาก-ถอน อัตโนมัติที่รวดเร็วและปลอดภัยตลอด 24 ชม." />
                                                            </div>
                                                    )
                                                }
                                            </div>
                                        </>
                                        :
                                        <div className={styles.boxMarginTop}>
                                            <div className={styles.bankPromotionComment}>
                                                ไม่สามารถเลือกโปรโมชั่นได้ เนื่องจากเครดิตของคุณมีมากกว่า {process.env.REACT_APP_BALANCE_LIMIT} เครดิต
                                            </div>
                                        </div>
                                )
                            }
                        </div>
                    </div>
                )
            }

            {
                depositItems?.promotion_name && (
                    <div className={styles.boxMarginTop}>
                        <div className={styles.boxDetailTop}>
                            <div className="transactionSlipSuccess center" style={{ padding: 0 }}>
                                <Grid container alignItems="center" justifyContent="center" spacing={2}>
                                    <Grid item>
                                        <CheckCircleIcon className="iconTransactionaction" />
                                    </Grid>
                                    <Grid item>
                                        เลือก{ depositItems?.promotion_name } สำเร็จ !
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                )
            }

        </>
    );
}